import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { overpowerContainer } from 'listing/layout/Container';

import { Link } from 'react-scroll';

export const Wrapper = styled.div`
	border-bottom: 1px solid ${getColor('alto')};
	background: ${getColor('white')};
	position: static;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 1023px) {
		margin-left: -25px;
		margin-right: -25px;
	}

	@media(max-width: 768px) {
		width: ${props => props.isSticky ? '100% !important' : 'calc(100% + 30px)'};
		margin-left: -15px;
		margin-right: -15px;
	}

`;

export const Overflower = styled.div`
	display: flex;
	align-items: center;
	flex: 1; /* grow inside parent flex container */
	min-width: 50%;
	overflow-x: auto;
	white-space: nowrap;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const Item = styled(Link)`
	display: block;
	cursor: pointer;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	color: ${getColor("gray")};
	text-decoration: none;
	margin-right: 15px;
	border-bottom: 4px solid transparent;
	padding: 16px;


	@media(max-width: 1250px) {
		padding: 16px 14px;
	}

	@media(max-width: 835px) {
		padding: 16px 10px;
	}

	@media(max-width: 767px) {
		margin: 0;
		padding: 17px 12px;
		white-space: nowrap;
	}

	&.is-current {
		color: ${getColor('darkTeal')};
		border-bottom-color: ${getColor('primaryBrand')};
	}
`;

export const ShareAndLike = styled.div`
	display: flex;
	align-items: center;
`;

export const StickyWrapper = styled.div`
	/* review elements should be under this */
	position: relative;
	z-index: 9;
`;
